import { render, staticRenderFns } from "./buy-price-sum.vue?vue&type=template&id=2ba5d9e8&scoped=true"
import script from "./buy-price-sum.vue?vue&type=script&lang=js"
export * from "./buy-price-sum.vue?vue&type=script&lang=js"
import style0 from "./buy-price-sum.vue?vue&type=style&index=0&id=2ba5d9e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba5d9e8",
  null
  
)

export default component.exports